import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PasswordRequestService } from './password-request.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { BasicService } from '../../services/basic.service';

@Component({
  selector: 'app-password-request',
  templateUrl: './password-request.component.html',
  styleUrls: ['./password-request.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PasswordRequestComponent {
  @Input() companyId: number;

  form: FormGroup = this.formBuilder.group({ email: [null, Validators.required] });

  constructor(
    private formBuilder: FormBuilder,
    private passwordRequestService: PasswordRequestService,
    private dialog: MatDialog,
    private basicService: BasicService
  ) {}

  submit() {
    const { email } = this.form.getRawValue();

    this.passwordRequestService.request(this.companyId, email).subscribe({
      next: () =>
        this.dialog.open(ConfirmDialogComponent, {
          data: {
            description: this.basicService.translate('password-request/link-sent', { email }),
            cancelBtnText: this.basicService.translate('close'),
          },
        }),
    });
  }
}
